// extracted by mini-css-extract-plugin
export default {"languageOption":"f8UxJ","optionList":"sKQjw"};